import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const maybeShowTaskPendingToast = async (me) => {
    try {
      // const today = new Date().toISOString().slice(0, 10);
      // const lastAck = localStorage.getItem('taskAckDate');
      // if (lastAck === today) return;

      const statsRes = await api.get('/task/stats');
      const stats = statsRes.data || {};
      const pending = Number(stats.pending || 0);
      if (pending > 0) {
        const name = [me?.name, me?.surname].filter(Boolean).join(' ') || me?.name || '';
        const id = toast.info(
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              maxWidth: 420
            }}
          >
            <div style={{ lineHeight: 1.4 }}>
              {name ? `Ciao ${name}, ` : ''}ci sono {pending} task da gestire.
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button
                onClick={() => {
                  // localStorage.setItem('taskAckDate', today);
                  toast.dismiss(id);
                }}
                style={{ padding: '6px 10px', borderRadius: 6, background: '#1976d2', color: '#fff', border: 0, cursor: 'pointer' }}
              >
                Ho preso visione
              </button>
              <button
                onClick={() => {
                  // localStorage.setItem('taskAckDate', today);
                  window.location.href = '/tasks';
                }}
                style={{ padding: '6px 10px', borderRadius: 6, background: '#2e7d32', color: '#fff', border: 0, cursor: 'pointer' }}
              >
                Vai ai Task
              </button>
              <button
                onClick={() => toast.dismiss(id)}
                style={{ padding: '6px 10px', borderRadius: 6, background: '#e0e0e0', color: '#333', border: 0, cursor: 'pointer' }}
              >
                Chiudi
              </button>
            </div>
          </div>,
          { autoClose: false, closeOnClick: false, position: 'top-right' }
        );
      }
    } catch {}
  };

  useEffect(() => {
    const checkLoggedIn = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const res = await api.get('/auth/me');
          setUser(res.data);
          await maybeShowTaskPendingToast(res.data);
        } catch (error) {
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };

    checkLoggedIn();
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    const meRes = await api.get('/auth/me');
    setUser(meRes.data);
    await maybeShowTaskPendingToast(meRes.data);
    return res.data;
  };

  const register = async (name, email, password) => {
    const res = await api.post('/auth/register', { name, email, password });
    localStorage.setItem('token', res.data.token);
    // After register we usually need to get user details or token contains payload
    // Here we can fetch me or just use what we have if backend returns user
    // The current backend register returns only token. So let's fetch me.
    const meRes = await api.get('/auth/me');
    setUser(meRes.data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const updateUser = (userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
